module.exports = __webpack_public_path__ + "7e4b29ba/img/share-action-icon.9c12578c.svg";